import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import { PARTS_ENDPOINT } from "../../consts";
import DynamicForm from "../../components/ui/dynamicForm/dynamicForm.component";
import { useHasPermission } from "../../contexts/auth";

export const StockStatusListActions = () => {
  const { t } = useTranslation();
  const [addPartOpened, setAddPartOpened] = useState<boolean>(false);
  const canAddPart = useHasPermission("service.add_part");

  const actions: Action[] = [{
    icon: <AddIcon />,
    label: t("Add new part"),
    onClick: () => { setAddPartOpened(true) },
    disabled: !canAddPart
  }];

  const handlePartAdded = () => {
    setAddPartOpened(false);
    window.dispatchEvent(new Event('partAdded'));
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addPartOpened}
        setOpened={setAddPartOpened}
        title={t("Add new part")}
        content={
          <DynamicForm
            url={PARTS_ENDPOINT}
            onSuccess={handlePartAdded}
          />
        }
      />
    </>
  );
};
